import { BaseCrewCoverage } from '../../../api/scheduler/models/base-crew-coverage';
import { BaseCrewRowDto } from '../../../api/scheduler/models/base-crew-row-dto';
import { Rank } from '../../../api/scheduler/models/rank';
import { Rotation } from '../../../api/scheduler/models/rotation';
import { BaseCrewMember, BaseStatus, CrewPriority, CrewRotation } from '../models';

const PRIORITY: Record<Rank, CrewPriority> = {
  PRIMARY: 'Primary',
  SECONDARY: 'Secondary',
  TERTIARY: 'Tertiary',
};

const ROTATION: Record<Rotation, CrewRotation> = {
  ROTATION_A: 'A',
  ROTATION_B: 'B',
  ROTATION_C: 'C',
};

export function toBaseCrewMember(dto: BaseCrewRowDto): BaseCrewMember {
  return {
    id: dto.id,
    crewId: dto.crewId,
    name: dto.fullName,
    crewCode: String(dto.crewId),
    email: dto.email ?? null,
    priority: PRIORITY[dto.rank],
    rotation: dto.rotation ? ROTATION[dto.rotation] : null,
    assignedOn: dto.assignedOn,
    status: (dto.status === 'INACTIVE' ? 'Inactive' : 'Active') as BaseStatus,
    isBaseLead: dto.baseLead,
    coverage: dto.coverage as BaseCrewCoverage,
  };
}
